import { Modal, ModalProps } from "@shopify/polaris";
import { useEffect } from "react";
import styles from "./CustomModal.module.css";

type Props_CustomModal = ModalProps & { noClose?: boolean };

const CustomModal = (props: Props_CustomModal) => {
    useEffect(() => {
        const container = document.getElementById("PolarisPortalsContainer");
        if (container && props.open) {
            if (props.noClose) container.classList.add(styles.modalNoClose);
            else container.classList.remove(styles.modalNoClose);
        }
    }, [props.open, props.noClose]);
    return (
        <Modal {...props}>
            <Modal.Section>{props.children}</Modal.Section>
        </Modal>
    );
};

export default CustomModal;
